import React, { useEffect } from "react";
import { useTranslation, Trans } from "react-i18next";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SignUpButton from "../../../SignUpButton";

export default function ScrollAnimation(props) {
  useEffect(() => {
    if (typeof window !== `undefined`) {
      gsap.registerPlugin(ScrollTrigger);
      gsap.core.globals("ScrollTrigger", ScrollTrigger);
    }

    const markerAnime = gsap.fromTo(
      ".contentMarker",
      { y: 100 },
      {
        y: 0,
        duration: 1.5,
        opacity: 1,
        paused: true,
      }
    );

    const displays = gsap.utils.toArray(".pin-container > *");

    const displayCount = displays.length;

    displays.forEach((display, index) => {
      display.anime = gsap.fromTo(
        display,
        { opacity: 0 },
        {
          duration: 1,
          opacity: 1,
          paused: true,
        }
      );
      display.percent = index / displayCount;
      if (index === 0) {
        display.anime.pause(1);
      }
    });

    let currPos = 0;

    // Set up our scroll trigger
    const ST = ScrollTrigger.create({
      trigger: ".content-container",
      start: "top top+=61px",
      end: "bottom bottom",
      //onUpdate: getCurrentSection,
      pin: ".pin-container",
      //markers: true,
      onEnter: function () {
        markerAnime.play();
      },
      onLeaveBack: function () {
        markerAnime.reverse();
      },
      onUpdate: ({ progress, direction, isActive }) => {
        let newPos = 0;

        if (progress > 0) {
          displays.forEach((display, index) => {
            if (progress > display.percent && index > newPos) {
              newPos = index;
            }
          });

          if (currPos !== 0 && currPos !== newPos) {
            displays[currPos].anime.reverse();
          }
          currPos = newPos;
          displays[newPos].anime.play();
        }

        if (progress === 0 && currPos !== 0) {
          displays[currPos].anime.reverse();
          currPos = 0;
        }
      },
    });

    ScrollTrigger.matchMedia({
      // desktop
      "(min-width: 768px)": function () {
        // setup animations and ScrollTriggers for screens 800px wide or greater (desktop) here...
        // These ScrollTriggers will be reverted/killed when the media query doesn't match anymore.

        // a loop for the other sections '.section'

        ST.enable();
      },
      // mobile
      "(max-width: 767px)": function () {
        ST.disable();
      },
      // all
      all: function () {
        // ScrollTriggers created here aren't associated with a particular media query,
        // so they persist.
      },
    });
  }, []);

  const { t } = useTranslation();

  return (
    <>
      <div
        id="token-vesting-sections"
        className="d-none d-md-block content-container"
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 gray-background">
              <div className="pin-container">
                <img
                  id="img1"
                  src={props.imageTokenDistribution.publicURL}
                  alt="Token Distribution"
                  className="img-fluid animation-placeholder"
                />

                <img
                  id="img2"
                  src={props.imageVestingSchedule.publicURL}
                  alt="Vesting Schedule"
                  className="img-fluid animation-placeholder"
                />
              </div>
            </div>

            <div className="col-md-6 d-flex justify-content-around flex-column scroll-spacer">
              <div
                className="contentMarker section-1"
                data-marker-content="img1"
              >
                <h2 className="text-center text-md-left lines">
                  <Trans
                    i18nKey="zmt.tokenVesting.token.title"
                    components={[]}
                  />
                </h2>
                <p className="text-center text-md-left lines">
                  <Trans
                    i18nKey="zmt.tokenVesting.token.description"
                    components={[<span>200M ZMT</span>]}
                  />
                </p>
                <div className="my-5">
                  <SignUpButton className="lines button button-secondary button-buy">
                    {t("zmt.btnOnBoard")} &#8594;
                  </SignUpButton>
                </div>
              </div>

              <div
                className="contentMarker section-2"
                data-marker-content="img2"
              >
                <h2 className="text-center text-md-left lines">
                  <Trans
                    i18nKey="zmt.tokenVesting.vesting.title"
                    components={[]}
                  />
                </h2>
                <p className="text-center text-md-left lines">
                  <Trans
                    i18nKey="zmt.tokenVesting.vesting.description"
                    components={[<span>4 year period</span>]}
                  />
                </p>
                <div className="my-5">
                  <SignUpButton className="lines button button-secondary button-buy">
                    {t("zmt.btnOnBoard")} &#8594;
                  </SignUpButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
